import React, { useEffect, useState } from "react";
import "./HomePage.scss";
import LifeTimeSummary from "./section/LifeTimeSummary";
import BillDue from "./payment/BillDue";
import { useSelector } from "react-redux";
import { getDashboardDataApi } from "services/dashboard";
import { failMessage } from "utils/toastMessage";
import { formatTimestamp, formatUnixTimestamp } from "utils/commonFun";

const HomePage = () => {
  const { selectedSite } = useSelector((state) => (state?.selectedSite))
  const [loader, setLoader] = useState(false)
  const [dashboardData, setDashboardData] = useState()
  // console.log('dashboardData', dashboardData)
  // const { orderId } = useParams()
  // --------get-Report-Data-listing-------------
  const getDashboardData = async () => {
    if (selectedSite?._id) {
      setLoader(true)
      try {
        const params = { plantId: selectedSite?._id, }
        const res = await getDashboardDataApi(params)
        if (res?.status === 200) {
          const data = res?.data
          setDashboardData(data || {})
        } else {
          failMessage(res)
        }
      } catch (e) {
        console.log('error', e?.message)
      } finally {
        setLoader(false)
      }
    }
  }
  useEffect(() => {
    getDashboardData()
  }, [selectedSite?._id,])

  return (
    <>
      <div className="home_page">
        <div className="container">
          {dashboardData?.lastUpdatedTime ? <p>Last Updated At : {formatUnixTimestamp(dashboardData?.lastUpdatedTime)}</p> : ""}
          {/* -------------Life-Time-Summary------------------ */}
          <LifeTimeSummary {...{ dashboardData }} />
          {/* -------------bill------------------ */}
          <BillDue />
        </div>
      </div>
    </>
  );
};

export default HomePage;
